import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

import { cronicleSections, sections } from "../config";
import { StaticQuery, graphql, Link } from "gatsby";
import { Typography } from "@mui/material";

type Anchor = "top" | "left" | "bottom" | "right";

export default function TemporaryDrawer() {
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer =
        (anchor: Anchor, open: boolean) =>
        (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === "keydown" &&
                ((event as React.KeyboardEvent).key === "Tab" ||
                    (event as React.KeyboardEvent).key === "Shift")
            ) {
                return;
            }

            setState({ ...state, [anchor]: open });
        };

    const list = (anchor: Anchor) => (
        <Box
            sx={{
                width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
            }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <Typography component="h3" variant="h5" sx={{ pl: 1, pt: 1, }}>
                Cronicle Press
            </Typography>
            <List>
                {cronicleSections.map((section, index) => (
                    <ListItem key={section.url} disablePadding>
                        <ListItemButton LinkComponent={Link} href={section.url}>
                            {/* <ListItemIcon>
                                    {index % 2 === 0 ? (
                                        <InboxIcon />
                                    ) : (
                                        <MailIcon />
                                    )}
                                </ListItemIcon> */}
                            <ListItemText primary={section.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <Typography component="h3" variant="h5" sx={{ pl: 1, pt: 1, }}>
                Resources
            </Typography>
            <List>
                {sections.map((section, index) => (
                    <ListItem key={section.url} disablePadding>
                        <ListItemButton LinkComponent={Link} href={section.url}>
                            {/* <ListItemIcon>
                                    {index % 2 === 0 ? (
                                        <InboxIcon />
                                    ) : (
                                        <MailIcon />
                                    )}
                                </ListItemIcon> */}
                            <ListItemText primary={section.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <Typography component="h3" variant="h5" sx={{ pl: 1, pt: 1, }}>
                Sections
            </Typography>
            <List>
                <StaticQuery
                    query={
                        graphql`
                        query AllCategories {
                            data: allCategoryNode(
                                sort: { category: ASC }
                            ) {
                                categories: nodes {
                                    category
                                    num
                                }
                            }

                        }
                        `
                    }
                    render={
                        ( { data } ) => {
                            console.log("data", data );
                            return data.categories.map(({ category }) => (
                                <ListItem key={`/categories/${category}`} disablePadding>
                                    <ListItemButton LinkComponent={Link} href={`/categories/${category}`}>
                                        <ListItemText primary={category} sx={{ textTransform: "capitalize" }} />
                                    </ListItemButton>
                                </ListItem>

                            ))
                        }

                    }
                />

            </List>
        </Box>
    );

    return (
        <div>
            <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={toggleDrawer("left", true)}
            >
                <MenuIcon />
            </IconButton>
            <Drawer
                anchor="left"
                open={state["left"]}
                onClose={toggleDrawer("left", false)}
            >
                {list("left")}
            </Drawer>
        </div>
    );
}


